/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sync_Status_TitleInputs */



/**
* | output |
* | --- |
* | "Sync status" |
*
* @param {Admin_Sync_Status_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_sync_status_title = /** @type {((inputs?: Admin_Sync_Status_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sync_Status_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("État de la synchronisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estado de la sincronización")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Status da sincronização")
	if (locale === "it") return /** @type {LocalizedString} */ ("Stato della sincronizzazione")
	return /** @type {LocalizedString} */ ("Sync status")
});